module.exports = __webpack_public_path__ + "static/media/3.3b35cba0.svg";